import { render, staticRenderFns } from "./StackedBarChart.vue?vue&type=template&id=b34aecac&"
import script from "./StackedBarChart.vue?vue&type=script&lang=ts&"
export * from "./StackedBarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports